"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currencies = exports.CryptoCurrencies = exports.CryptoTokens = exports.Fiats = exports.ArbitrumTokens = exports.SolanaTokens = exports.BaseTokens = exports.PolygonTokens = exports.TronTokens = exports.BscTokens = exports.EthTokens = exports.CryptoCoins = void 0;
const definitions_1 = require("@ppay/definitions");
exports.CryptoCoins = [
    {
        name: 'Bitcoin',
        ticker: definitions_1.Ticker.BTC,
        decimals: 8,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.BITCOIN,
        cryptoForce: {
            payway: 'btc',
            currency: 'BTC'
        }
    },
    {
        name: 'Ethereum',
        ticker: definitions_1.Ticker.ETH,
        decimals: 18,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.ETHEREUM,
        cryptoForce: {
            payway: 'eth',
            currency: 'ETH'
        }
    },
    {
        name: 'BNB',
        ticker: definitions_1.Ticker.BNB,
        decimals: 18,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.BINANCE_SMART_CHAIN,
        cryptoForce: {
            payway: 'bsc',
            currency: 'BNB'
        }
    },
    {
        name: 'TRON',
        ticker: definitions_1.Ticker.TRX,
        decimals: 6,
        formatDecimals: 6,
        blockchain: definitions_1.Blockchain.TRON,
        cryptoForce: {
            payway: 'tron',
            currency: 'TRX'
        }
    },
    {
        name: 'Polygon',
        ticker: definitions_1.Ticker.POL,
        decimals: 18,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.POLYGON,
        cryptoForce: {
            payway: 'polygon_eth',
            currency: 'POL'
        }
    },
    {
        name: 'Ethereum',
        ticker: definitions_1.Ticker.ETH,
        decimals: 18,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.BASE,
        cryptoForce: {
            payway: 'base_eth',
            currency: 'ETH'
        }
    },
    {
        name: 'Solana',
        ticker: definitions_1.Ticker.SOL,
        decimals: 9,
        formatDecimals: 9,
        blockchain: definitions_1.Blockchain.SOLANA,
        cryptoForce: {
            payway: 'sol',
            currency: 'SOL'
        }
    },
    {
        name: 'Arbitrum',
        ticker: definitions_1.Ticker.ETH,
        decimals: 18,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.ARBITRUM,
        cryptoForce: {
            payway: 'arbitrum_eth',
            currency: 'ETH'
        }
    },
    {
        name: 'Litecoin',
        ticker: definitions_1.Ticker.LTC,
        decimals: 8,
        formatDecimals: 8,
        blockchain: definitions_1.Blockchain.LITECOIN,
        cryptoForce: {
            payway: 'ltc',
            currency: 'LTC'
        }
    }
];
exports.EthTokens = [
    {
        name: 'Tether USD',
        ticker: definitions_1.Ticker.USDT,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'erc20',
            currency: 'USDT'
        }
    },
    {
        name: 'USD Coin',
        ticker: definitions_1.Ticker.USDC,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'erc20',
            currency: 'USDC'
        }
    },
    {
        name: 'BNB',
        ticker: definitions_1.Ticker.BNB,
        decimals: 18,
        formatDecimals: 8,
        cryptoForce: {
            payway: 'erc20',
            currency: 'BNB'
        }
    },
    {
        name: 'Shiba Inu',
        ticker: definitions_1.Ticker.SHIB,
        decimals: 18,
        formatDecimals: 8,
        cryptoForce: {
            payway: 'erc20',
            currency: 'SHIB'
        }
    },
    {
        name: 'Pepe',
        ticker: definitions_1.Ticker.PEPE,
        decimals: 18,
        formatDecimals: 8,
        cryptoForce: {
            payway: 'erc20',
            currency: 'PEPE'
        }
    }
].map((t) => (Object.assign(Object.assign({}, t), { coinTicker: definitions_1.Ticker.ETH, blockchain: definitions_1.Blockchain.ETHEREUM })));
exports.BscTokens = [
    {
        name: 'Tether USD',
        ticker: definitions_1.Ticker.USDT,
        decimals: 18,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'bep20',
            currency: 'USDT'
        }
    },
    {
        name: 'USD Coin',
        ticker: definitions_1.Ticker.USDC,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'bep20',
            currency: 'USDC'
        }
    },
    {
        name: 'Dogecoin',
        ticker: definitions_1.Ticker.DOGE,
        decimals: 8,
        formatDecimals: 8,
        cryptoForce: {
            payway: 'bep20',
            currency: 'DOGE'
        }
    },
    {
        name: 'Shiba Inu',
        ticker: definitions_1.Ticker.SHIB,
        decimals: 18,
        formatDecimals: 8,
        cryptoForce: {
            payway: 'bep20',
            currency: 'SHIB'
        }
    },
    {
        name: 'Ethereum',
        ticker: definitions_1.Ticker.ETH,
        decimals: 18,
        formatDecimals: 8,
        cryptoForce: {
            payway: 'bep20',
            currency: 'ETH'
        }
    }
].map((t) => (Object.assign(Object.assign({}, t), { coinTicker: definitions_1.Ticker.BNB, blockchain: definitions_1.Blockchain.BINANCE_SMART_CHAIN })));
exports.TronTokens = [
    {
        name: 'Tether USD',
        ticker: definitions_1.Ticker.USDT,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'trc20',
            currency: 'USDT'
        }
    }
].map((t) => (Object.assign(Object.assign({}, t), { coinTicker: definitions_1.Ticker.TRX, blockchain: definitions_1.Blockchain.TRON })));
exports.PolygonTokens = [
    {
        name: 'USD Coin',
        ticker: definitions_1.Ticker.USDC,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'polygon_erc20',
            currency: 'USDC'
        }
    }
].map((t) => (Object.assign(Object.assign({}, t), { coinTicker: definitions_1.Ticker.POL, blockchain: definitions_1.Blockchain.POLYGON })));
exports.BaseTokens = [
    {
        name: 'USD Coin',
        ticker: definitions_1.Ticker.USDC,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'base_erc20',
            currency: 'USDC'
        }
    }
].map((t) => (Object.assign(Object.assign({}, t), { coinTicker: definitions_1.Ticker.ETH, blockchain: definitions_1.Blockchain.BASE })));
exports.SolanaTokens = [
    {
        name: 'USD Coin',
        ticker: definitions_1.Ticker.USDC,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'spl',
            currency: 'USDC'
        }
    },
    {
        name: 'Tether USD',
        ticker: definitions_1.Ticker.USDT,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'spl',
            currency: 'USDT'
        }
    }
].map((t) => (Object.assign(Object.assign({}, t), { coinTicker: definitions_1.Ticker.SOL, blockchain: definitions_1.Blockchain.SOLANA })));
exports.ArbitrumTokens = [
    {
        name: 'USD Coin',
        ticker: definitions_1.Ticker.USDC,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'arbitrum_erc20',
            currency: 'USDC'
        }
    },
    {
        name: 'Tether USD',
        ticker: definitions_1.Ticker.USDT,
        decimals: 6,
        formatDecimals: 2,
        cryptoForce: {
            payway: 'arbitrum_erc20',
            currency: 'USDT'
        }
    }
].map((t) => (Object.assign(Object.assign({}, t), { coinTicker: definitions_1.Ticker.ETH, blockchain: definitions_1.Blockchain.ARBITRUM })));
exports.Fiats = [
    {
        name: 'US Dollar',
        ticker: definitions_1.Ticker.USD,
        symbol: '$',
        decimals: 2,
        formatDecimals: 2
    },
    {
        name: 'Ukrainian hryvnia',
        ticker: definitions_1.Ticker.UAH,
        symbol: '₴',
        decimals: 2,
        formatDecimals: 2
    },
    {
        name: 'Euro',
        ticker: definitions_1.Ticker.EUR,
        symbol: '€',
        decimals: 2,
        formatDecimals: 2
    }
];
exports.CryptoTokens = [
    ...exports.EthTokens,
    ...exports.BscTokens,
    ...exports.TronTokens,
    ...exports.PolygonTokens,
    ...exports.BaseTokens,
    ...exports.SolanaTokens,
    ...exports.ArbitrumTokens
];
exports.CryptoCurrencies = [...exports.CryptoCoins, ...exports.CryptoTokens];
exports.Currencies = [...exports.Fiats, ...exports.CryptoCurrencies];
